<template>
  <div class="te-back-frame">
    <Menu />
    <div class="te-main">
      <Header />
      <div class="te-content">
        <router-view :key="t" :menu-feature="menuFeature" class="h-100" />
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Features/Header';
import Menu from '@/components/Features/Menu';

// eslint-disable-next-line no-unused-expressions
import(/* webpackPreload: true */'@/assets/styles/te-back-frame.min.css');

export default {
  components: {
    Header,
    Menu
  },
  props: {
    t: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      user: {}
    };
  },
  computed: {
    menuFeature() {
      let feature = {};
      if (this.$store.getters.currentFeature) {
        const recursive = (features, featureObj) => {
          const newFeature = { ...featureObj };
          features.forEach((elem) => {
            if (elem.children.length > 0) {
              newFeature[elem.id] = recursive(elem.children, newFeature[elem.id]);
            } else {
              newFeature[elem.id] = {};
            }
          });
          return newFeature;
        };
        feature = recursive(this.$store.getters.currentFeature.features, feature);
      }
      return feature;
    },
    userId() {
      return this.$store.getters.userId;
    }
  }
};
</script>
